import { Component } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoaderMode } from '../state/loader/loader.actions';
import { LoaderState } from '../state/loader/loader.state';

@Component({
  selector: 'tcc-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {

  public show$: Observable<boolean>;
  public mode$: Observable<LoaderMode>;
  public value$: Observable<number>;


  constructor(private store: Store) {
    this.show$ = this.store.select(LoaderState.show);
    this.mode$ = this.store.select(LoaderState.mode);
    this.value$ = this.store.select(LoaderState.value);
  }

}
